(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-cross-sell"] && !Shopify.designMode) return;
  try {
    if (!window.productBundleCrossSellToggleReady) {
  window.productBundleCrossSellToggleReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bundle-toggle]');
    if (!button) return;
    const bundle = button.closest('.product-bundle-cross-sell');
    if (!bundle) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    bundle.querySelectorAll('[data-bundle-extra]').forEach((item) => {
      item.hidden = expanded;
    });
    button.setAttribute('aria-expanded', String(!expanded));
  });
}
  } catch(e) { console.error(e); }
})();

})();
